/* jsl-bonusy.js — J·SKIN LAB BON1 (25.09.2026): bonusy w koszyku bez aplikacji.
 *  Konfiguracja: <script type="application/json" data-jsl-bonusy-cfg> z snippets/jsl-prezent-zasoby (metapole sklepu jsl.bonusy):
 *   { cele: [{ id: "maska", v: <wariant 0 zł>, k: <próg w groszach/centach waluty koszyka> }], bez: "_jsl_bonus_bez" }.
 *   Cel jest w konfiguracji tylko wtedy, gdy jsl.bonusy.aktywny = true i produkt-bonus jest opublikowany i dostępny.
 *  Po każdej zmianie koszyka (zdarzenie motywu cart:update) liczymy sumę PREPARATÓW: bez produktów z tagami „bonus” i
 *   „usluga-prezent” (pudełko, wysyłka prezentu), po rabatach (final_line_price). Suma ≥ próg → 1 szt. bonusu z właściwością
 *   _bonus=<id>; suma < próg → bonus znika; więcej niż 1 szt. → wraca do 1. Tagi produktów bierzemy z /products/<uchwyt>.js
 *   (pamięć w sessionStorage), bo cart.js ich nie podaje.
 *  „Nie chcę” przy bonusie: bonus znika, a jego id trafia do atrybutu koszyka _jsl_bonus_bez (ukryty w kasie) — nie wraca, dopóki
 *   klientka nie kliknie „Przywróć” na karcie bonusu. Kasa niczego tu nie pilnuje: przy pakowaniu ERP sprawdza, czy zamówienie
 *   ma próg dla bonusu (bonus bez progu = nie pakujemy).
 *  Znacznik: gdy bonusy działają, koszyk dostaje ukryty atrybut _jsl_bonusy („v1;PLN;maska=200;mini=500;klub=1;kurs=4.25”) —
 *   ERP (Magazyn → Zamówienia) liczy z niego „Dołóż do paczki” i sprawdza próg bonusu przy pakowaniu.
 *  Efekt „super”: nowa karta bonusu (data-jsl-bonus-karta) dostaje klasę is-swiezy raz, gdy pojawi się po raz pierwszy
 *   (prefers-reduced-motion wyłącza ruch w CSS).
 */
(function () {
  if (window.jslBonusy) return;
  window.jslBonusy = true;

  var ZRODLO = 'jsl-bonusy';
  var cfg = null;
  function konfig() {
    if (cfg) return cfg;
    var el = document.querySelector('script[data-jsl-bonusy-cfg]');
    try { cfg = el ? JSON.parse(el.textContent) : null; } catch (e) { cfg = null; }
    return cfg;
  }
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (konfig() && konfig().root) || '/';
    return r.slice(-1) === '/' ? r : r + '/';
  }
  function api(sciezka, cialo) {
    return fetch(root() + sciezka, {
      method: cialo ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: cialo ? JSON.stringify(cialo) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  // tagi produktów (cart.js ich nie ma) — pamięć na czas sesji
  var PAM = 'jsl-bonusy-tagi';
  var tagi = {};
  try { tagi = JSON.parse(sessionStorage.getItem(PAM) || '{}') || {}; } catch (e) { tagi = {}; }
  function zapiszTagi() { try { sessionStorage.setItem(PAM, JSON.stringify(tagi)); } catch (e) { /* tryb prywatny */ } }
  function tagiDla(handle) {
    if (tagi[handle]) return Promise.resolve(tagi[handle]);
    return api('products/' + encodeURIComponent(handle) + '.js')
      .then(function (p) { tagi[handle] = (p && p.tags) || []; zapiszTagi(); return tagi[handle]; })
      .catch(function () { return []; });
  }

  function odrzucone(cart, c) { return String((cart.attributes || {})[c.bez || '_jsl_bonus_bez'] || '').split(',').filter(Boolean); }

  function odswiez(cart) {
    var e = new Event('cart:update', { bubbles: true });
    e.detail = { resource: cart || null, sourceId: ZRODLO, data: { source: ZRODLO, itemCount: cart ? cart.item_count : 0 } };
    document.dispatchEvent(e);
  }

  var trwa = false, znowu = false, zegar = null;
  function zaplanuj() { clearTimeout(zegar); zegar = setTimeout(synchronizuj, 120); }
  function synchronizuj() {
    var c = konfig();
    if (!c) return;
    c.cele = c.cele || [];
    if (trwa) { znowu = true; return; }
    trwa = true;
    api('cart.js').then(function (cart) {
      var vids = c.cele.map(function (x) { return String(x.v); });
      return Promise.all(cart.items.map(function (i) {
        if (vids.indexOf(String(i.variant_id)) >= 0) return Promise.resolve(['bonus']);
        return tagiDla(i.handle);
      })).then(function (lt) {
        var suma = 0;
        cart.items.forEach(function (i, n) {
          var t = lt[n] || [];
          if (t.indexOf('bonus') >= 0 || t.indexOf('usluga-prezent') >= 0) return;
          suma += i.final_line_price;
        });
        var bez = odrzucone(cart, c), kroki = [];
        c.cele.forEach(function (cel) {
          var linie = cart.items.filter(function (i) { return String(i.variant_id) === String(cel.v); });
          var ile = linie.reduce(function (a, i) { return a + i.quantity; }, 0);
          var chce = suma >= cel.k && bez.indexOf(cel.id) < 0;
          if (chce && ile === 0) kroki.push(function () { return api('cart/add.js', { items: [{ id: Number(cel.v), quantity: 1, properties: { _bonus: cel.id } }] }); });
          else if (!chce && ile > 0) { var up = {}; linie.forEach(function (i) { up[i.key] = 0; }); kroki.push(function () { return api('cart/update.js', { updates: up }); }); }
          else if (chce && (ile > 1 || linie.length > 1)) {
            var up2 = {}; linie.forEach(function (i, k) { up2[i.key] = k === 0 ? 1 : 0; }); kroki.push(function () { return api('cart/update.js', { updates: up2 }); });
          }
        });
        // bonus, którego nie ma już w konfiguracji (wyłączony, niedostępny) — zdejmujemy
        var ids = c.cele.map(function (x) { return x.id; }), stare = {};
        cart.items.forEach(function (i) { var b = i.properties && i.properties._bonus; if (b && ids.indexOf(b) < 0) stare[i.key] = 0; });
        if (Object.keys(stare).length) kroki.push(function () { return api('cart/update.js', { updates: stare }); });
        // znacznik dla ERP (atrybut ukryty w kasie): zapisujemy po cichu, bez odświeżania koszyka
        var zn = c.znacznik || '', jest = (cart.attributes || {})._jsl_bonusy || '';
        var znacznik = zn !== jest && cart.item_count > 0 ? function () { return api('cart/update.js', { attributes: { _jsl_bonusy: zn } }); } : null;
        if (!kroki.length) return znacznik ? znacznik() : null;
        if (znacznik) kroki.push(znacznik);
        return kroki.reduce(function (p, f) { return p.then(f); }, Promise.resolve()).then(function () { return api('cart.js'); }).then(odswiez);
      });
    }).catch(function (e) { if (window.console) console.warn('jsl-bonusy', e); })
      .then(function () { trwa = false; if (znowu) { znowu = false; zaplanuj(); } });
  }

  // „Nie chcę” (wiersz bonusu) i „Przywróć” (karta pominiętego bonusu)
  function ustawBez(id, dodaj) {
    var c = konfig() || {}; var atr = c.bez || '_jsl_bonus_bez';
    return api('cart.js').then(function (cart) {
      var lista = odrzucone(cart, c).filter(function (x) { return x !== id; });
      if (dodaj) lista.push(id);
      var a = {}; a[atr] = lista.join(',');
      var cialo = { attributes: a };
      if (dodaj) {
        var up = {}; cart.items.forEach(function (i) { if (i.properties && i.properties._bonus === id) up[i.key] = 0; });
        (c.cele || []).forEach(function (x) { if (x.id === id) cart.items.forEach(function (i) { if (String(i.variant_id) === String(x.v)) up[i.key] = 0; }); });
        cialo.updates = up;
      }
      return api('cart/update.js', cialo);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-jsl-bonus-bez], [data-jsl-bonus-przywroc]');
    if (!b) return;
    e.preventDefault();
    var nie = b.hasAttribute('data-jsl-bonus-bez');
    var id = nie ? b.getAttribute('data-jsl-bonus-bez') : b.getAttribute('data-jsl-bonus-przywroc');
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    ustawBez(id, nie).then(function (cart) {
      if (nie) { odswiez(cart); return; }
      // przywrócony: najpierw zdejmujemy znacznik, potem zwykła synchronizacja dokłada bonus
      znowu = false; synchronizuj();
      setTimeout(function () { api('cart.js').then(odswiez); }, 50);
    }).catch(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
  });

  // efekt przy nowej karcie bonusu: raz na pojawienie się (zniknięcie karty zeruje pamięć, ponowne przekroczenie progu znów błyśnie)
  var WID = 'jsl-bonusy-widziane';
  function widziane() { try { return JSON.parse(sessionStorage.getItem(WID) || '[]'); } catch (e) { return []; } }
  function ustawWidziane(l) { try { sessionStorage.setItem(WID, JSON.stringify(l)); } catch (e) { /* nic */ } }
  var pierwsze = true;
  function swiezosc() {
    var karty = document.querySelectorAll('[data-jsl-bonus-karta]');
    var byly = widziane(), teraz = [];
    karty.forEach(function (k) {
      var id = k.getAttribute('data-jsl-bonus-karta');
      if (teraz.indexOf(id) < 0) teraz.push(id);
      if (byly.indexOf(id) < 0 && !pierwsze && !k.classList.contains('is-swiezy')) {
        k.classList.add('is-swiezy');
        setTimeout(function () { k.classList.remove('is-swiezy'); }, 2600);
      }
    });
    // pierwsze wejście na stronę: bonusy, które już były w koszyku, nie błyskają
    ustawWidziane(teraz);
    pierwsze = false;
  }
  var obs = null;
  function obserwuj() {
    if (obs || !('MutationObserver' in window)) return;
    var t = null;
    obs = new MutationObserver(function () { clearTimeout(t); t = setTimeout(swiezosc, 60); });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('cart:update', function (e) {
    var d = (e.detail && e.detail.data) || {};
    if (d.source === ZRODLO || d.didError) return;
    zaplanuj();
  });
  function start() { swiezosc(); obserwuj(); if (konfig()) zaplanuj(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
